import { Select as AntSelect, Empty, SelectProps } from 'antd'
import { useFormatData, useUtil } from 'hooks'
import { IOptionItem } from 'interfaces'
import { ReactNode, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledSelect = styled(AntSelect)<any>`
  height: 36px;
  width: 100%;
  .ant-select-focused,
  .ant-select {
    height: 100%;
    width: 100%;
  }
  .ant-select .ant-select-selector,
  .ant-select-selector,
  .ant-select-focused {
    outline: none !important;
    height: 100% !important;
    border: none !important;
    border-bottom: 1px solid var(--color-gray-103) !important;
    border-radius: 0 !important;
    padding: 0px !important;
    box-shadow: none !important;
  }

  &.ant-select-focused .ant-select-selector {
    border-bottom: 1px solid var(--color-primary-109) !important;
  }

  .ant-select-selection-placeholder {
    left: 0 !important;
    right: 0 !important;
  }

  .ant-select-selection-search {
    margin-left: 0 !important;
  }
  &.prevent-edit .ant-select-selector {
    color: inherit !important;
    background: inherit !important;
    cursor: not-allowed !important;
  }
  .ant-select-selection-item {
    label .title {
      font-weight: 400;
    }
    label {
      cursor: pointer;
    }
  }
`
const StyledLabel = styled.label`
  color: var(--color-gray-111);
  font-weight: 600;
  font-size: 1.4rem;
  span {
    color: var(--color-red-107);
  }
`
const StyledOptionItem = styled.label`
  color: var(--color-gray-111);
  font-weight: 600;
  font-size: 1.4rem;
  .title {
  }
  .description {
    font-weight: 400;
  }
`
interface IProps extends SelectProps<any, any> {
  title?: string | ReactNode
  children?: ReactNode
  defaultValue?: any
  required?: boolean
  options?: Array<IOptionItem>
  preventInput?: boolean
  fieldTransform?: any
  value?: any
  showDescription?: boolean
  selectRef?: any
}

const Select = (props: IProps) => {
  const { t } = useTranslation()
  const { removeVietnameseTones } = useFormatData()
  const { getOptions } = useUtil()
  const {
    title,
    placeholder,
    required,
    defaultValue,
    className,
    options,
    preventInput,
    children,
    fieldTransform,
    value,
    showDescription,
    selectRef,
    ...selectProps
  } = props
  const [privateValue, setPrivateValue] = useState(value)
  const [optionsTran, setOptionsTran] = useState<any>([])
  useEffect(() => {
    const options = getOptions(props?.options || [])
    if (fieldTransform || (showDescription && !preventInput)) {
      let optionsPrivate = []
      if (
        options &&
        options?.length > 0 &&
        typeof options[0].label === 'string'
      ) {
        optionsPrivate = options?.map((o: any) => {
          o['label'] = t(o?.label)
          return o
        })
      }
      if (
        options &&
        options?.length > 0 &&
        typeof options[0].label === 'string' &&
        options[0]?.description
      ) {
        optionsPrivate = options?.map((o: any) => {
          o['label'] = (
            <StyledOptionItem>
              <div className="title">{t(o?.label)}</div>
              <div className="description">{t(o?.description)}</div>
            </StyledOptionItem>
          )
          return o
        })
      }
      setOptionsTran(optionsPrivate)
      setPrivateValue(value)
    } else {
      const option = options?.find(
        (op) => op?.value?.toString() === value?.toString()
      )
      setPrivateValue(option || value)
    }
  }, [options, value, preventInput, showDescription])

  return (
    <div className={className}>
      <StyledLabel>
        {typeof title === 'string' ? t(title || '') : title}
        {required && typeof title === 'string' && <span> *</span>}
      </StyledLabel>
      <StyledSelect
        ref={selectRef}
        defaultValue={defaultValue}
        placeholder={t(placeholder?.toString() || '')}
        options={
          optionsTran?.length > 0 ? optionsTran : getOptions(options || [])
        }
        disabled={preventInput}
        className={preventInput ? 'prevent-edit' : ''}
        filterOption={(input: string, option: any) => {
          const name = removeVietnameseTones(option?.label).toLowerCase()
          const keySearch = removeVietnameseTones(input).toLowerCase()
          return name?.includes(keySearch)
        }}
        value={privateValue}
        notFoundContent={
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={t('no-data')}
          />
        }
        {...selectProps}>
        {children}
      </StyledSelect>
    </div>
  )
}

export default Select
